import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field, reduxForm } from 'redux-form';
import { Form, Modal, Message } from 'semantic-ui-react';

// Actions
import {
    requestCreateQuantityForecast,
    requestUpdateQuantityForecast
    // @ts-ignore
} from 'services/quantityForecasts/actions';

// Components
import SubmittingSection from 'components/SubmissionSection';
// @ts-ignore
import EntityHierarchyReversed from '../../../EntityHierarchyReversed';

// Form
// @ts-ignore
import { normalizers, validators, RenderField } from '../../../../forms';

// Selectors
// @ts-ignore
import { selectInitialValues } from './selectors';
// @ts-ignore
import { makeSelectQuantityForecastValue } from '../../../../services/quantityForecasts/selectors';
import { makeSelectQueryStringNumberValue } from '../../../../workspaces/react-router-selectors';

// Validators
const { isNumber, isRequiredNumber } = validators;

// Normalizers
const { toNumber, toNullIfNaN } = normalizers;

// Constants
const NAMESPACE = ['QUANTITY_FORECAST_CREATE', 'QUANTITY_FORECAST_UPDATE'];

interface Props {
    actualForecastId?: number;
    selectedEntity?: number;
    handleSubmit: Function;
    onClose: Function;
    requestCreateQuantityForecast: Function;
    requestUpdateQuantityForecast: Function;
    error?: string;
}

class ForecastForm extends React.PureComponent<Props> {
    handleSubmit = (values: Record<string, any>): void => {
        const { selectedEntity, actualForecastId, ...props } = this.props;

        if (actualForecastId) {
            props.requestUpdateQuantityForecast(actualForecastId, values);
        } else {
            props.requestCreateQuantityForecast({
                ...values,
                entityId: selectedEntity
            });
        }
    };

    render(): React.ReactElement {
        const { selectedEntity, error, handleSubmit, onClose } = this.props;
        return (
            <React.Fragment>
                <Modal.Header>
                    <EntityHierarchyReversed entityId={selectedEntity} />
                </Modal.Header>
                <Modal.Content className="constrain-width">
                    <Form
                        onSubmit={handleSubmit(this.handleSubmit)}
                        autoComplete="off"
                    >
                        <Field
                            name="value"
                            component={RenderField as any}
                            label="Forecasted bins"
                            type="number"
                            placeholder="Enter forecasted bins"
                            validate={[isRequiredNumber, isNumber]}
                            parse={toNumber}
                        />
                        <Field
                            name="size"
                            component={RenderField as any}
                            label="Estimated Count Size"
                            type="number"
                            placeholder="Enter count size"
                            validate={isNumber}
                            parse={toNumber}
                            normalize={toNullIfNaN}
                        />
                        {error && <Message negative>{error}</Message>}
                        <SubmittingSection
                            submittingButtonParam={{
                                namespace: NAMESPACE
                            }}
                            normalCancelButtonParam={{
                                onClose: (): void => {
                                    onClose();
                                }
                            }}
                        />
                    </Form>
                </Modal.Content>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    initialValues: selectInitialValues,
    actualForecastId: makeSelectQuantityForecastValue('id'),
    selectedEntity: makeSelectQueryStringNumberValue('selectedEntity')
});

export default connect(mapStateToProps, {
    requestCreateQuantityForecast,
    requestUpdateQuantityForecast
})(
    reduxForm<any, any>({
        form: 'forecastForm'
    })(ForecastForm)
);
